import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Loader } from "../Components/Loader";

import Dashboard from "../Pages/Dashboard";
import ListDashboard from "../Pages/Dashboard/List";

import CreateCompany from "../Pages/CompanyInfo/Create";
import ListCompany from "../Pages/CompanyInfo/List";
import EditCompany from "../Pages/CompanyInfo/Edit";
import CompanyBranding from "../Pages/CompanyBranding";


import PlatformCompanies from "../Pages/Platform/Companies";
import CompanyProfile from "../Pages/Platform/CompanyProfile";
import PlatformUsers from "../Pages/Platform/Users";
import PlatformRoles from "../Pages/Platform/Roles";
import PlatformNumbers from "../Pages/Platform/Numbers";
import PlatformProviders from "../Pages/Platform/Providers";
import PlatformApiClients from "../Pages/Platform/ApiClients";
import PlatformWebhooks from "../Pages/Platform/Webhooks";
import PlatformSystemHealth from "../Pages/Platform/SystemHealth";
import PlatformIntegrations from "../Pages/Platform/IntegrationsCenter";
import PlatformTemplates from "../Pages/Platform/Templates";
import PlatformDocumentation from "../Pages/Platform/Documentation";
import BillingDashboard from "../Pages/Billing/Dashboard";
import BillingInvoices from "../Pages/Billing/Invoices";
import BillingPaymentMethods from "../Pages/Billing/PaymentMethods";
import BillingPlans from "../Pages/Billing/Plans";
import BillingPayments from "../Pages/Billing/Payments";
import SmsLogs from "../Pages/Sms/Logs";
import WhatsAppSettings from "../Pages/WhatsApp/Settings";
import CallHistory from "../Pages/Voice/CallHistory";
import Inbox from "../Pages/Inbox";

/**
 * INTALK app routes.
 *
 * Phase 0: MrVeggie POS + legacy CRM screens stripped. Remaining = the clean
 * platform shell (dashboard, companies, branding, team). The customer
 * inbox/conversations UI is built fresh in Phase 5.
 */
const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Suspense fallback={<Loader />}>
            <Navigate to="/dashboard" />
          </Suspense>
        }
      />

      <Route
        path="/dashboard"
        element={
          <Suspense fallback={<Loader />}>
            <Dashboard />
          </Suspense>
        }
      />
      <Route
        path="/dashboard/list"
        element={
          <Suspense fallback={<Loader />}>
            <ListDashboard />
          </Suspense>
        }
      />

      <Route
        path="/company/create"
        element={
          <Suspense fallback={<Loader />}>
            <CreateCompany />
          </Suspense>
        }
      />
      <Route
        path="/company/list"
        element={
          <Suspense fallback={<Loader />}>
            <ListCompany />
          </Suspense>
        }
      />
      <Route
        path="/company-history/:id"
        element={
          <Suspense fallback={<Loader />}>
            <EditCompany />
          </Suspense>
        }
      />
      <Route
        path="/settings/branding"
        element={
          <Suspense fallback={<Loader />}>
            <CompanyBranding />
          </Suspense>
        }
      />

      {/* INTALK Platform (Phase 1) */}
      <Route path="/platform/companies" element={<Suspense fallback={<Loader />}><PlatformCompanies /></Suspense>} />
      <Route path="/companies/:id" element={<Suspense fallback={<Loader />}><CompanyProfile /></Suspense>} />
      <Route path="/platform/users" element={<Suspense fallback={<Loader />}><PlatformUsers /></Suspense>} />
      <Route path="/platform/roles" element={<Suspense fallback={<Loader />}><PlatformRoles /></Suspense>} />
      <Route path="/platform/numbers" element={<Suspense fallback={<Loader />}><PlatformNumbers /></Suspense>} />
      <Route path="/platform/providers" element={<Suspense fallback={<Loader />}><PlatformProviders /></Suspense>} />
      <Route path="/platform/api-clients" element={<Suspense fallback={<Loader />}><PlatformApiClients /></Suspense>} />
      <Route path="/platform/webhooks" element={<Suspense fallback={<Loader />}><PlatformWebhooks /></Suspense>} />
      <Route path="/platform/system-health" element={<Suspense fallback={<Loader />}><PlatformSystemHealth /></Suspense>} />
      <Route path="/platform/integrations" element={<Suspense fallback={<Loader />}><PlatformIntegrations /></Suspense>} />
      <Route path="/platform/templates" element={<Suspense fallback={<Loader />}><PlatformTemplates /></Suspense>} />
      <Route path="/platform/documentation" element={<Suspense fallback={<Loader />}><PlatformDocumentation /></Suspense>} />
      <Route path="/billing" element={<Suspense fallback={<Loader />}><BillingDashboard /></Suspense>} />
      <Route path="/billing/invoices" element={<Suspense fallback={<Loader />}><BillingInvoices /></Suspense>} />
      <Route path="/billing/payment-methods" element={<Suspense fallback={<Loader />}><BillingPaymentMethods /></Suspense>} />
      <Route path="/billing/plans" element={<Suspense fallback={<Loader />}><BillingPlans /></Suspense>} />
      <Route path="/billing/payments" element={<Suspense fallback={<Loader />}><BillingPayments /></Suspense>} />
      <Route path="/sms/logs" element={<Suspense fallback={<Loader />}><SmsLogs /></Suspense>} />
      <Route path="/whatsapp/settings" element={<Suspense fallback={<Loader />}><WhatsAppSettings /></Suspense>} />
      <Route path="/voice/calls" element={<Suspense fallback={<Loader />}><CallHistory /></Suspense>} />
      <Route path="/inbox" element={<Suspense fallback={<Loader />}><Inbox /></Suspense>} />

      <Route element={<Navigate replace to="/dashboard" />} path="*" />
    </Routes>
  );
};

export default AppRoutes;
